<template>
  <div>
    <div class="uk-section" style="margin-top:50px;">
      <h1>Contáctenos</h1>
      <div class="uk-container uk-container-small">
          <div class="uk-child-width-1-2@m" uk-grid>
            <div class="uk-card uk-card-default uk-card-body">
                <form
                  class="uk-grid-small"
                  @submit.prevent="submit"
                  uk-grid
                >
                  <legend class="uk-legend">Envíenos un mensaje</legend>
                  <div class="uk-width-1-1" >
                    <label class="uk-form-label form__label" for="form-stacked-nombre">Nombre</label>
                    <input 
                      class="uk-input form__input" 
                      :class="{ 'uk-form-danger': $v.nombre.$error }"
                      id="form-stacked-nombre" 
                      type="text" 
                      placeholder="Su nombre..."
                      v-model.trim="$v.nombre.$model"
                    />
                  </div>
                  <small class="error" v-if="!$v.nombre.required && $v.nombre.$error">Este campo es requerido</small>
                  <div class="uk-width-1-2@s">
                    <label class="uk-form-label" for="form-stacked-correo">Correo</label>
                    <input
                      class="uk-input"
                      :class="{ 'uk-form-danger': $v.email.$error }"
                      id="form-stacked-correo"
                      type="text"
                      placeholder="Su correo electrónico..."
                      v-model.trim="$v.email.$model"
                    >
                    <small class="error" v-if="!$v.email.required && $v.email.$error">Este campo es requerido</small>
                    <small class="error" v-if="!$v.email.email && $v.email.$error">Correo no válido</small>
                  </div>
                  <div class="uk-width-1-2@s">
                    <label class="uk-form-label" for="form-stacked-telefono">Teléfono</label>
                    <input 
                      class="uk-input" 
                      :class="{ 'uk-form-danger': $v.telefono.$error }"
                      id="form-stacked-telefono" 
                      type="text" 
                      placeholder="Su teléfono o celular..."
                      v-model.trim="$v.telefono.$model"
                    >
                    <small class="error" v-if="!$v.telefono.required && $v.telefono.$error">Este campo es requerido</small>
                  </div>
                  <div class="uk-width-1-1">
                    <label class="uk-form-label" for="form-stacked-tema">Tema</label>
                    <input 
                      class="uk-input" 
                      :class="{ 'uk-form-danger': $v.tema.$error }"
                      id="form-stacked-tema" 
                      type="text" 
                      placeholder="Tema del mensaje..."
                      v-model.trim="$v.tema.$model"
                    >
                    <small class="error" v-if="!$v.tema.required && $v.tema.$error">Este campo es requerido</small>
                  </div>
                  <div class="uk-width-1-1">
                    <label class="uk-form-label" for="form-stacked-mensaje">Mensaje</label>
                    <textarea
                      class="uk-textarea" 
                      :class="{ 'uk-form-danger': $v.mensaje.$error }"
                      id="form-stacked-mensaje" 
                      rows="4"
                      placeholder="Su mensaje..."
                      v-model.trim="$v.mensaje.$model"
                    >
                    </textarea>
                    <small class="error" v-if="!$v.mensaje.required && $v.mensaje.$error">Este campo es requerido</small>
                  </div>
                  <div class="uk-width-1-1">
                    <div class="uk-form-controls">
                      <button
                         type="submit" 
                          class="uk-button uk-button-secondary"
                      >
                        Enviar
                      </button>
                    </div>
                  </div>
                </form>
          </div>
          <div class="uk-child-width-1-2@m" uk-grid>
            <div class="social-wrapper">
              <div v-for="item in social" :key="item.icon" class="social">
                  <a 
                    :uk-icon="item.icon"
                    :href="item.link"
                    target="_blank"
                  >
                  </a>
                  <a 
                    :href="item.link"
                    target="_blank"
                  >
                  {{ item.text }}
                  </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import UIkit from 'uikit'
// import { gmapsMap, gmapsMarker } from 'x5-gmaps'
import { required, email } from 'vuelidate/lib/validators'
import gql from "graphql-tag";
export default {
  // components: { gmapsMap, gmapsMarker },
  data() {
    return {
      social: [
        {
          icon: 'mail',
          link: 'mailto:contacto@cuseremp.pe',
          text: 'contacto@cuseremp.pe'
        },
        {
          icon: 'phone',
          link: 'tel:+51922353955',
          text: '(51) 922 353 955'
        },
        {
          icon: 'whatsapp',
          link: 'https://wa.me/51922353955',
          text: '(51) 922 353 955'
        },
        {
          icon: 'phone',
          link: 'tel:+51977934252',
          text: '(51) 977 934 252'
        },
        {
          icon: 'whatsapp',
          link: 'https://wa.me/51977934252',
          text: '(51) 977 934 252'
        },
        {
          icon: 'linkedin',
          link: 'https://www.linkedin.com/company/cuseremp/',
          text: '/cuseremp'
        },
        {
          icon: 'facebook',
          link: 'https://www.facebook.com/CUSEREMP',
          text: '/cuseremp'
        },
        {
          icon: 'instagram',
          link: 'https://www.instagram.com/cuseremp_sac/?hl=es-la',
          text: '@cuseremp_sac'
        }
      ],
      errors: [],
      nombre: null,
      email: null,
      telefono: null,
      tema: null,
      mensaje: null,
      submitStatus: null,
    }
  },
  validations: {
    nombre: {
      required,
    },
    email: {
      required,
      email
    },
    telefono: {
      required,
    },
    tema: {
      required
    },
    mensaje: {
      required
    }
  },
  methods: {
    submit() {
      console.log('submit!')
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
      } else {
        // do your submit logic here
        this.sendMessage()
        this.submitStatus = 'PENDING'
        setTimeout(() => {
          this.submitStatus = 'OK'
        }, 500)
      }
    },
    async sendMessage(){
      try {
        const variables = {
          nombre: this.nombre,
          email: this.email,
          telefono: this.telefono,
          tema: this.tema,
          mensaje: this.mensaje,
        }
        const rowInserted = await this.$apollo.mutate({
          mutation: gql`
            mutation(
              $nombre:String, 
              $email:String,
              $telefono:String,
              $tema:String,
              $mensaje:String,
              ){
              createContacto(
                input: {
                  data: {
                    name: $nombre, 
                    email: $email,
                    telefono: $telefono,
                    tema: $tema,
                    mensaje: $mensaje
                  }
                }){
                contacto{
                  id
                }
              }
            }
          `,
          variables:{...variables}
        })
        if(rowInserted){
          UIkit.notification({
            message: 'Se envió su mensage!',
            status: 'success',
            pos: 'bottom-center',
            timeout: 5000
          });
          this.nombre=null
          this.email=null
          this.telefono=null
          this.tema=null
          this.mensaje=null
          this.$v.$reset()
        }
      } catch (error) {
        console.log("Error al enviar mensaje", error)
      }
    }
  },
}
</script>

<style scoped>
  .height-3{
    height: 300px;
  }
  .contact-wrapper{
    display: flex;

  }
  .social-wrapper{
    width: 100%;
    margin-top: 3rem;
  }
  .social-wrapper>div{
    width: 100%;
  }
  .social{
    color: #333;
    margin-bottom: 20px;
  }
  .social>a{
    color: #333;
    margin-right: 20px;
    font-size: 1.2rem;
  }
</style>